import React from 'react';

function ChatList({ chatrooms, selectedChat, onChatSelect, loading, error }) {
    // Use real chatrooms data from API
    const contacts = chatrooms;
    
    return (
        <div className="h-full flex flex-col bg-white rounded-l-2xl">
            {/* Header */}
            <div className="px-6 py-6 border-b border-gray-200 bg-gray-50 rounded-tl-2xl flex-shrink-0">
                <h2 className="text-lg font-semibold text-gray-800">My Students & Support</h2>
            </div>
            
            {/* Contact List */}
            <div className="flex-1 overflow-y-auto py-2">
                {loading ? (
                    <div className="p-5 text-center text-gray-600">Loading conversations...</div>
                ) : error ? (
                    <div className="p-5 text-center text-red-600">{error}</div>
                ) : contacts.length === 0 ? (
                    <div className="p-5 text-center text-gray-600">No conversations found</div>
                ) : (
                    <div className="px-2">
                        {contacts.map((contact) => (
                            <div 
                                key={contact.id} 
                                onClick={() => onChatSelect(contact)}
                                className={`flex items-start p-5 mx-2 mb-2 rounded-xl cursor-pointer transition-all duration-200 hover:bg-gray-50 hover:shadow-md hover:-translate-y-0.5 ${
                                    selectedChat?.id === contact.id ? 'bg-gray-50 shadow-sm' : 'bg-white'
                                }`}
                            >
                                {/* Avatar */}
                                <div className="relative mr-4 flex-shrink-0">
                                    <div 
                                        className="w-13 h-13 rounded-full flex items-center justify-center text-white font-semibold text-lg shadow-sm"
                                        style={{ backgroundColor: contact.avatarColor }}
                                    >
                                        {contact.avatar}
                                    </div>
                                    {contact.isOnline && (
                                        <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 border-2 border-white rounded-full"></div>
                                    )}
                                </div>
                                
                                {/* Contact Info */}
                                <div className="flex-1 min-w-0 relative">
                                    <div className="font-semibold text-gray-800 text-base mb-1">
                                        {contact.name}
                                    </div>
                                    <div className="text-sm text-gray-500 mb-1">
                                        {contact.role}
                                        {contact.timezone && contact.role === 'Student' && (
                                            <span className="ml-2 text-xs text-blue-600 bg-blue-100 px-2 py-0.5 rounded-full">
                                                {contact.timezone}
                                            </span>
                                        )}
                                    </div>
                                    <div className="text-sm text-gray-600 mb-1 truncate max-w-48">
                                        {contact.lastMessage}
                                    </div>
                                    <div className="text-xs text-gray-400">
                                        {contact.lastMessageTime}
                                    </div>
                                    
                                    {/* Unread Badge */}
                                    {contact.unreadCount > 0 && (
                                        <div className="absolute top-0 right-0 bg-red-500 text-white text-xs font-semibold rounded-full w-6 h-6 flex items-center justify-center shadow-sm">
                                            {contact.unreadCount}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default ChatList;
